import React, { useState, useEffect } from "react";
import API from "../../services/api";
import { t } from "@lingui/macro";

const MyTickets = () => {
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    API.get("/api/users/tickets")
      .then((response) => setTickets(response.data))
      .catch((error) => console.error("Error fetching tickets:", error));
  }, []);

  const handleDownload = (ticketId) => {
    console.log("Chcemy pobrac bilet o id " + ticketId);
    API.get(`/api/users/tickets/${ticketId}/download`, { responseType: "blob" })
      .then((response) => {
        console.log("Response status:", response.status);
        if (response.status !== 200) {
          throw new Error("Download failed.");
        }
        return response.data;
      })
      .then((blob) => {
        console.log("Blob size:", blob.size);
        const link = document.createElement("a");
        const url = window.URL.createObjectURL(blob);
        link.href = url;
        link.download = `${ticketId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  return (
    <div>
      <h2>{t`My Tickets`}</h2>
      <p>{t`View and manage your active tickets.`}</p>

      <div className="tickets-list">
        {tickets.length === 0 ? (
          <p>{t`No active tickets found.`}</p>
        ) : (
          <ul>
            {tickets.map((ticket) => (
              <li key={ticket.id}>
                <div className="ticket-item">
                  <p>
                    <strong>{t`Ticket ID:`}</strong> {ticket.id}
                  </p>
                  <p>
                    <strong>{t`Expiration Date:`}</strong> {ticket.expirationDate}
                  </p>
                  <button
                    onClick={() => handleDownload(ticket.id)}
                    className="download-btn"
                  >
                    {t`Download PDF`}
                  </button>
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default MyTickets;
